import { Routes } from '@angular/router';

import { authGuard } from './shared/auth/auth.guard';
import { pendingChatReloadRedirectGuard } from './shared/chat/pending-chat-reload.guard';
import { unknownRouteRedirectGuard } from './shared/routing/unknown-route-redirect.guard';

export const routes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    title: 'AskPC | Your AI Analyst for Indian Private Markets',
    loadComponent: () =>
      import('./pages/landing/landing-page.component').then((m) => m.LandingPageComponent),
  },
  {
    path: 'disclaimer',
    title: 'Disclaimer | AskPC by PrivateCircle',
    loadComponent: () =>
      import('./pages/disclaimer/disclaimer-page.component').then((m) => m.DisclaimerPageComponent),
  },
  {
    path: 'trace/:conversationId',
    title: 'Trace | AskPC',
    canMatch: [authGuard],
    loadComponent: () =>
      import('./pages/trace/trace-page.component').then((m) => m.TracePageComponent),
  },
  {
    path: '',
    loadComponent: () =>
      import('./layout/app-shell/app-shell.component').then((m) => m.AppShellComponent),
    children: [
      {
        path: 'app',
        title: 'Home | AskPC',
        canMatch: [authGuard],
        loadComponent: () =>
          import('./pages/home/home-page.component').then((m) => m.HomePageComponent),
      },
      {
        path: 'app/:conversationId',
        title: 'Chat | AskPC',
        canMatch: [authGuard, pendingChatReloadRedirectGuard],
        loadComponent: () =>
          import('./pages/chat/chat-page.component').then((m) => m.ChatPageComponent),
      },
      {
        path: 'search',
        title: 'Search | AskPC',
        canMatch: [authGuard],
        loadComponent: () =>
          import('./pages/search/search-page.component').then((m) => m.SearchPageComponent),
      },
      {
        path: 'sources',
        title: 'Sources | AskPC',
        canMatch: [authGuard],
        loadComponent: () =>
          import('./pages/sources/sources-page.component').then((m) => m.SourcesPageComponent),
      },
      {
        path: 'usage',
        title: 'Usage | AskPC',
        canMatch: [authGuard],
        loadComponent: () =>
          import('./pages/usage/usage-page.component').then((m) => m.UsagePageComponent),
      },
      {
        path: 'subscription',
        pathMatch: 'full',
        redirectTo: 'plans',
      },
      {
        path: 'subscriptions',
        pathMatch: 'full',
        redirectTo: 'plans',
      },
      {
        path: 'plans',
        title: 'Plans | AskPC',
        canMatch: [authGuard],
        loadComponent: () =>
          import('./pages/subscription/subscription-page.component').then(
            (m) => m.SubscriptionPageComponent,
          ),
      },
      {
        path: 'faq',
        title: 'FAQ | AskPC',
        canMatch: [authGuard],
        loadComponent: () =>
          import('./pages/faq/faq-page.component').then((m) => m.FaqPageComponent),
      },
    ],
  },
  { path: '**', canMatch: [unknownRouteRedirectGuard], children: [] },
];
